// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"528":"codemirror","909":"notifications","961":"returns"}[chunkId] + "." + {"528":"dde3c144f64b968161e7","909":"958993662a6c8bfdd0cc","961":"02aee0ea4d9ca9749dc9"}[chunkId] + ".css";
};